import { IdFilter  } from 'react3l-advanced-filters';
import { ModelFilter } from 'react3l-common';
import { ObjectField } from "react3l-decorators";

export class ResponsibilityRoleMappingFilter extends ModelFilter  {
  @ObjectField(IdFilter)
  public responsibilityId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public roleId?: IdFilter = new IdFilter();
  public search?: string = null;
}
